import { Game } from "shared/games/types/Game";
import { EQTypes } from "../organisms/Graph/types";

export function gameTypeToEQType(game: Game): EQTypes {
  if (game === Game.freq_finder_boost) {
    return "boost";
  }

  if (game === Game.freq_finder_cut) {
    return "cut";
  }

  if (game === Game.freq_finder_hipass) {
    return "hipass";
  }

  if (game === Game.freq_finder_lopass) {
    return "lopass";
  }

  throw new Error(`Unknown game type ${game}`);
}

export function gameTypeToBiquadFilterType(game: Game): BiquadFilterType {
  if (game === Game.freq_finder_hipass) {
    return "highpass";
  }

  if (game === Game.freq_finder_lopass) {
    return "lowpass";
  }

  return "peaking";
}
